import { Slider as SliderComponent } from "@/js/components/Slider";

const SELECTOR = ".js-slider";
const SLIDES_SELECTOR = ".js-slider__slides";
const SLIDE_SELECTOR = ".js-slider__slide";
const NAV_SELECTOR = ".js-slider__nav";

class Slider {
    static attach(container) {
        const sliderElements = container.querySelectorAll(SELECTOR);
        if (sliderElements) {
            [...sliderElements].forEach((sliderElement) => {
                const sliderNavElement = sliderElement.querySelector(NAV_SELECTOR);
                /* eslint-disable-next-line no-unused-vars */
                const slider = new Slider(sliderElement, sliderNavElement);
            });
        }
    }

    constructor(slider, nav) {
        this.sliderElement = slider;
        this.navElement = nav;
        this.slider = null;

        this.createNavElement();
        this.createSlider();
    }

    createNavElement() {
        this.navElement.innerHTML = "";
        [...this.sliderElement.querySelectorAll(SLIDE_SELECTOR)].forEach(() => {
            this.navElement.insertAdjacentHTML("beforeend", "<span></span>");
        });
    }

    createSlider() {
        this.slider = new SliderComponent({
            container: this.sliderElement.querySelector(SLIDES_SELECTOR),
            navContainer: this.navElement
        });
    }
}

export { Slider };
